export default [
  {
    path: '/BAHome/',
    component: () => import('@/components/Layer.vue'),
    children: [
      {
        path: '',
        name: 'BAHome',
        component: () => import('@/views/BAHome/index.vue'),
        meta: {
          prev: 'goHome',
          header: 'management'
        }
      }
    ]
  }
]
